import { FlowStepData } from "../FlowStepData";
import { MultiExecutableOutputDefinition } from "../../../Common/Execution/MultiExecutable";

export class LongOutputTestStep extends FlowStepData {
    readonly __type: string = "long_output_test";

    paths: string[] = ["the answer is yes", "the answer is no", "the answer is maybe"];

    firstPathMustContinue: boolean = true;

    constructor() {
        super();
        this.name = "Long Output Test Step";
    }

    getStorageData(): object {
        let data = super.getStorageData();

        Reflect.set(data, "firstPathMustContinue", this.firstPathMustContinue);
        return data;
    }

    setStorageData(data: object) {
        super.setStorageData(data);

        this.firstPathMustContinue = Reflect.get(data, "firstPathMustContinue");
    }

    getOutcomes(): MultiExecutableOutputDefinition[] {
        return this.paths.map((value) => {
            return new MultiExecutableOutputDefinition(value);
        });
    }
}
